
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1800 156","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1800 .033v122.531c-65.746.325-126.423-.176-182.031-1.503 2.258 27.665 25.902 30.637 10.306 27.646-10.501-2.014-18.905-11.507-25.212-28.479l.17.459a4248.6 4248.6 0 01-53.106-1.754c-.074.154-.151.31-.23.468-12.624 25.55 12.386 43.523.276 33.043-6.412-5.549-9.321-14.524-8.728-26.923-5.415 9.403-11.942 14.839-19.58 16.306-14.792 2.842 5.767.303 9.797-23.669-47.106-2.093-89.728-4.918-127.866-8.474-151.156-14.091-491.113-24.32-666.767-14.091C619.926 102.41 374.249 111.65 0 123.309V.033h1800z","fill":"#97D26F","fill-rule":"evenodd"}})])
          )
        }
      }
    